import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-report-problem',
  templateUrl: './report-problem.component.html',
  styleUrls: ['./report-problem.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportProblemComponent {}
